import { useContext, useEffect } from 'react'

import { Loader } from '@paysense-india-services/elevate-web'

import { LOGOUT_API } from '@/constants/api'

import { AuthContext } from '@/contexts/AuthContext'

import { useFetch } from '@/hooks/useFetch'

import ErrorPage from '@/components/ErrorPage'

const LogoutPage = () => {
  const { logoutUser } = useContext(AuthContext)
  const { loading, error, apiRequest } = useFetch(LOGOUT_API)

  useEffect(() => {
    const performLogout = async () => {
      await apiRequest({ method: 'post' })
      logoutUser()
    }
    performLogout()
  }, [apiRequest, logoutUser])

  if (loading) {
    return <Loader color='brand' loadingText='Signing Out...' pageLoader size='large' />
  }
  if (error) {
    return <ErrorPage />
  }
  return <Loader color='brand' loadingText='Redirecting to login...' pageLoader size='large' />
}

export default LogoutPage
